import axios, { axiosNT } from '../../../services/axios';

const list = () => axios
	.get('/class/classList')
	.then((res) => Promise.resolve(res.data));

const getGaolWiseConceptAndChapter = (courseTypeIds: any[]) => axiosNT
	.post('/courseSyllabus/v4/class', { courseTypeIds })
	.then((res) => Promise.resolve(res))

export default {
	list,
	getGaolWiseConceptAndChapter
};